import React from "react";
import "./EraPage.css"; // Reuse shared styles with Cold War custom additions

function ColdWar() {
  return (
    <div className="era-page">
      {/* Banner */}
      <div className="era-banner coldwar-banner">
        <h1>🛰️ Cold War: The World on Edge</h1>
        <p className="era-subtitle">Grade 8 - Cold War Era</p>
      </div>

      {/* Overview */}
      <section className="coldwar-overview">
        <h2>🌍 What Was the Cold War?</h2>
        <p>
          The Cold War wasn’t a war with tanks and soldiers fighting in fields. It was a long time (about 45 years!) when countries were nervous about each other, especially the <strong>United States</strong> and the <strong>Soviet Union</strong>. They were afraid of a real war with nuclear weapons, so they tried to outsmart each other with space missions, spies, and powerful alliances.
        </p>
      </section>

      {/* Key Figures & Events */}
      <section className="coldwar-key">
        <h2>🔍 Key Moments & People</h2>
        <ul>
          <li>🛰️ <strong>Space Race:</strong> USA and USSR both wanted to be the first in space.</li>
          <li>☢️ <strong>Nuclear Standoff:</strong> Both sides had dangerous weapons ready to go.</li>
          <li>🇨🇦 <strong>Canada’s Role:</strong> Canada helped with peacekeeping and was part of NATO.</li>
          <li>🕵️ <strong>Spies & Secrets:</strong> Espionage was a big part of Cold War tension.</li>
          <li>🧱 <strong>Berlin Wall:</strong> A real wall that split a city in Germany for 28 years!</li>
        </ul>
      </section>

      {/* Story or Comic */}
      <section className="coldwar-story">
        <h2>📖 Story: “The Boy and the Balloon”</h2>
        <p>
          In East Berlin, young <strong>Lukas</strong> watched his red balloon float over the giant wall. He wondered about the other side of the city, where kids like him went to school and played. One day, he saw a balloon float back... with a note attached: “Hello from the West!”.
        </p>
      </section>

      {/* Video */}
      <section className="coldwar-media">
        <h2>🎥 Watch & Learn</h2>
        <img
    className="coldwar-illustration"
    src="/images/coldwar-era-scene.png" // Make sure the filename/path matches your project!
    alt="Illustration of two kids, US and USSR flags, globe, dove, rocket, handshake, and Olympic rings representing the Cold War"
    style={{
      width: "100%",
      maxWidth: 500,
      borderRadius: "1.5rem",
      margin: "0 auto",
      boxShadow: "0 4px 24px rgba(0,0,0,0.12)"
    }}
  />
      </section>

      {/* Quiz or Challenge */}
      <section className="coldwar-quiz">
        <h2>🧠 Quick Questions!</h2>
        <ol>
          <li>What were the two main countries involved in the Cold War?</li>
          <li>What wall separated East and West Germany?</li>
          <li>Why was it called a “Cold” war?</li>
        </ol>
        <p><em>(Discuss these with a friend or in your journal!)</em></p>
      </section>

      {/* Timeline */}
      <section className="coldwar-timeline">
        <h2>📅 Cold War Timeline</h2>
        <ul>
          <li>1947 – Cold War begins after WWII</li>
          <li>1961 – Berlin Wall is built</li>
          <li>1969 – USA lands on the moon</li>
          <li>1989 – Berlin Wall falls</li>
          <li>1991 – Cold War ends with the breakup of the Soviet Union</li>
        </ul>
      </section>
    </div>
  );
}

export default ColdWar;
